import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/src/node_modules/.pnpm/next@15.5.15_@babel+core@7.26.10_@opentelemetry+api@1.9.1_@playwright+test@1.52.0_babel_34916a44671fab46835adeca27b6f92e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/klarna/components/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/klarna/components/klarna_DE.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
